import { required, minLength } from '@vuelidate/validators';

// Keep in sync with Label model:
// UNICODE_CHARACTER_NUMBER_HYPHEN_UNDERSCORE = /\A[\p{L}\p{N}]+[\p{L}\p{N}_-]+\Z/
export const validLabelCharacters = (str = '') =>
  /^[\p{L}\p{N}]+[\p{L}\p{N}_-]+$/u.test(String(str || ''));

export const getLabelTitleErrorMessage = validation => {
  let errorMessage = '';
  if (!validation.title.$error) {
    errorMessage = '';
  } else if (!validation.title.required) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.REQUIRED_ERROR';
  } else if (!validation.title.minLength) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.MINIMUM_LENGTH_ERROR';
  } else if (!validation.title.validLabelCharacters) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.VALID_ERROR';
  }
  return errorMessage;
};

export default {
  title: {
    required,
    minLength: minLength(2),
    validLabelCharacters,
  },
  description: {},
  color: {
    required,
  },
  showOnSidebar: {},
};
